import { connect } from 'react-redux';
import { createSelector } from 'reselect';
import {
  accessingCurrentSpaceAsStaff,
  commonRoomPostsExcludingRecentImportantSelector,
  participantCount,
  recentImportantPostsSelector,
  participants,
} from '@core/selectors/classroom';

import { getCurrentSpaceId } from '@core/selectors/space';
import { currentUser } from '@core/selectors/user';
import { fetchClassRoomParticipants } from '@core/actions/classRoom/participants';
import CommonRoomResponsive from './CommonRoomResponsive';

export const responsiveCommonRoomPostsSelector = createSelector(
  [
    recentImportantPostsSelector,
    commonRoomPostsExcludingRecentImportantSelector,
  ],
  (recentPosts, posts) => [...recentPosts, ...posts].filter(Boolean)
);

const mapStateToProps = (state) => {
  const spaceId = getCurrentSpaceId(state);
  const user = currentUser(state);

  return {
    isFetchingParticipants: state.classRoom.isFetchingParticipants,
    participantTotal: participantCount(state),
    participants: participants(state, spaceId),
    readOnly: accessingCurrentSpaceAsStaff(state),
    spaceId,
    posts: commonRoomPostsExcludingRecentImportantSelector(state),
    author: user
      ? {
          firstName: user.firstName || '',
          lastName: user.lastName || '',
          avatarUrl: user.avatar,
        }
      : undefined,
  };
};

const mapDispatchToProps = (dispatch) => ({
  fetchParticipantsPreview: () =>
    dispatch(
      fetchClassRoomParticipants({ reset: true, skip: 0, sort: undefined })
    ),
});
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(CommonRoomResponsive);
